import React from 'react';
import ReactDOM from 'react-dom';
import Main from './Main';
import axios from 'axios';
import Config from './shared/Config';

import './styles/main.scss';

axios.defaults.baseURL = Config('API_BASE');
axios.defaults.headers.common['X-WP-Nonce'] = Config('NONCE');

if(document.getElementById('menopause-test-root')){
  ReactDOM.render(
    <React.StrictMode>
      <Main></Main>
    </React.StrictMode>,
    document.getElementById('menopause-test-root')
  );
  document.getElementById('menopause-test-root').classList.add('loading');
}